import React, { useEffect ,useState} from 'react';
import * as myConstClass from '../utils/fileWithConstants';
import Axios from 'axios';
import {
  Alert, 
} from "reactstrap";
import loaderimage from "./assets/loader-table.gif";
import "../TableComponent/TableDevice.css";


const CtcAddRemoveFactory = ({field, imei, batch,callbackParent,apifunction, Value_start, Value_end}) => {

  const token = localStorage.getItem("token");
  const api_host = process.env.REACT_APP_API_URL || myConstClass.REACT_APP_API_URL;
  var uri;
  var encodedURI;
  const[display,setDisplay] = useState("")
  const[isLoading,setisLoading]=useState(false)
  const[data,setdata]=useState([])
  const[feedback,setfeedback]=useState("")
  const[alertType,setalertType]=useState("info")
  const[visible,setvisible]=useState(false)

  
  const Test = ({display}) => (
    <div>
      {display.map(display => (
        <div className="display" key={display.imei}>{display.msg}</div>
      ))}
    </div>
  ); 

  function onDismiss(){
    setvisible(false)
  }

  var uriString = field;


  useEffect(()=>{
    if (imei !== "") {
      uriString = uriString+`&value_start=`+imei
    }else if(Value_start !== "" && Value_end !== ""){
      uriString = uriString+`&value_start=`+Value_start+`&value_end=`+Value_end
    }
    if (apifunction === 'add') {     
      uri = `${api_host}/factory/ctc_adddevices?field=`+uriString+`&batch=`+batch
    } 
    else if (apifunction ==='remove') {
      uri = `${api_host}/factory/ctc_removedevices?field=`+field+`&value=`+imei
    }
  },[field, imei, Value_start,Value_end, batch, apifunction])

  useEffect(()=>{
    encodedURI = encodeURI(uri);
    console.log("uri:", uri)
    console.log("encodeURI:", encodedURI)

    setisLoading(true)
    Axios(encodedURI, {
      method: 'POST', 
      headers: {
        'Authorization': `ApiKey ${token}`,
        'Content-Type': 'application/json'
      },
    })
    .then(res => {
      // console.log("response: ",res);
      console.log("your res are", res.data)
      setDisplay(res.data);
      setdata(data);
      setisLoading(false);
      setvisible(true);
      setfeedback("成功");
    })
    .catch(error=> {
      console.log ({...error});

      console.log ("error： ",error.response.data.error);
      console.log ("error123： ",error);
      var err_msg = JSON.stringify(error.response.data.error);
      setisLoading(false);
      setvisible(true);
      setfeedback("錯誤："+error.response.data.error);
      setfeedback("錯誤1："+err_msg);

      setalertType("danger")
    })
  },[])

  useEffect(()=>{
    console.log('data from fetch:', data);
  },[data]) 

  useEffect(()=>{
    callbackParent(field);
  },[])

  if (isLoading) {
    return <img src={loaderimage} alt="载入中..." />;
  }

  return(
    <>
    <Alert color={alertType} isOpen={visible} toggle={() => onDismiss()}>
      {feedback}
    </Alert>
    <div>
      {display.ok}
    </div>

    </>    
  )
}

export default CtcAddRemoveFactory;